import Component from 'umg-ember-backend/components/record-explorer';

export default class RecordExplorerForNewsletterComponent extends Component {
  // Defaults
  defaultColumns = ['id', 'primaryTarget.name', 'cmsModified'];

  tableColumns = [
    {
      property: 'id',
      sortable: true,
    },
    {
      property: 'primaryTarget.name',
      isMainColumn: true,
    },
    {
      property: 'cmsModified',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
    {
      property: 'cmsCreated',
      sortable: true,
      type: 'date',
      format: 'L LT',
      align: 'right',
    },
  ];
}
